export default "__VITE_ASSET__CTOIjExY__"